module.exports = __webpack_public_path__ + "img/pragmatic.8c7884da.svg";